<template>
  <accordion-simple-item  data-ui="create.project" title="Neues Projekt" :flex="true">
    <div class="flex flex-grow flex-col overflow-auto h-full pt-6 ">

      <div class="flex">
              <span class=" flex flex-col justify-center w-1/5 p-1 pt-1"
                    data-ui="description-create-project-name">Name:</span>
        <input v-if="!crateYeaNO" v-model="name" class="border flex-grow p-1 my-1"
               :class="{'border border-red-500': showError && isNameMissing}" type="text"
               data-ui="create-project-name-input">
        <input v-else v-model="showName" class="border flex-grow p-1 my-2" type="text">
      </div>
      <div class="flex">

              <span class=" flex flex-col justify-center w-1/5 p-1 pt-1"
                    data-ui="description-create-project-from">Von:</span>
        <input :class="{'border border-red-500': showError && isFromMissing}"
               v-if="!crateYeaNO" v-model="from" class="border flex-grow p-1 my-1"
               type="date" data-ui="create-project-from-input">
        <input v-else v-model="showFrom" class="border flex-grow p-1 my-1" type="text">
      </div>
      <div class="flex">

              <span class="flex flex-col justify-center w-1/5 p-1 pt-1"
                    data-ui="description-create-project-until">Bis:</span>
        <input :class="{'border border-red-500': showError && isToMissing}" v-if="!crateYeaNO" v-model="to"
               class="border flex-grow p-1 my-1" type="date" data-ui="create-project-until-input">
        <input v-else v-model="showTo" class="border flex-grow p-1 my-1" type="text">
      </div>

      <button v-if="!crateYeaNO" @click="newProject"
              class="p-1 bg-white mt-4 mb-4 w-full hover:bg-trader-blue hover:text-white"
              data-ui="create-project-button">
        Erstellen
      </button>
      <div v-if="isNameMissing">
        <span style="color:red">Bitte Projektnamen angeben</span>
      </div>
      <div v-if="isFromMissing">
        <span style="color:red">Bitte Beginn angeben</span>
      </div>
      <div v-if="isToMissing">
        <span style="color:red">Bitte Ende angeben</span>
      </div>
    </div>

  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import SignalBus from "@/application/SignalBus";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";

export default {
  name: "SPurchaser",
  data() {
    return {
      teamSearch: "",
      purchaser: [],
      colors: [],
      crateYeaNO: false,
      name: "",
      from: "",
      to: "",
      showName: "",
      showFrom: "",
      showTo: "",
      isNameMissing: false,
      isFromMissing: false,
      isToMissing: false,
      showError: false,
    }
  },

  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  methods: {
    async newProject() {
      this.isNameMissing = !this.name;
      this.isFromMissing = !this.from;
      this.isToMissing = !this.to;

      if (this.isNameMissing || this.isFromMissing || this.isToMissing) {
        this.showError = true;
      } else {
        this.showError = false;
      }



      let strFrom = this.from || '';
      let strTo = this.to || '';

      
      this.from = strFrom.replace(/\D/g, '');
      this.from = parseInt(this.from, 10) || null;
      this.to = strTo.replace(/\D/g, '');
      this.to = parseInt(this.to, 10) || null;

      

      const projectData = {
        name: this.name,
        from: this.from,
        to: this.to,
      }
      const mutation = gql`
        mutation createProject($project: ProjectInput!) {
           createProject(project: $project) {
            success
          }
        }
      `;
      try {
        const variables = {
          project: projectData
        };
        this.name = '';
        const {data} = await apolloClient.mutate({mutation, variables});
        SignalBus.emit("sidebar-reload-projects");
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {

  },
  watch: {},
}
</script>